export default function Youtube({ ...props }) {
  return (
    <svg
      viewBox="0 0 300 300"
      width={props.size}
      height={props.size}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="YouTube"
      {...props}
    >
      <rect
        width="300"
        height="300"
        rx="150"
        ry="150"
        fill={
          props.color === "white" || props.color === "mobile-nav"
            ? "#ffffff"
            : "#FF0000"
        }
      />
      <path
        d="M149.93750587 79.22267364s-63.21885.000059-79.08593926 4.12304707c-8.49578714 2.37380204-15.49140825 9.36950015-17.86523429 17.99023729-4.12295306 15.86710025-4.12304706 48.72656078-4.12304706 48.72656078s.000094 32.98420052 4.12304706 48.60156077c2.37382604 8.62062014 9.24450615 15.49138025 17.86523429 17.86524029 15.99203025 4.24788007 79.08593926 4.24804007 79.08593926 4.24804007s63.34418101-.00005 79.21094127-4.12304007c8.62079014-2.37381004 15.49133025-9.11966015 17.74023028-17.86524029 4.24793007-15.74232025 4.24805007-48.60156077 4.24805007-48.60156077s.12484-32.98446053-4.24805007-48.85156078c-2.24890003-8.62073714-9.11944014-15.49133425-17.74023028-17.74023729-15.86676026-4.37284707-79.21094127-4.37304707-79.21094127-4.37304707zm-20.11523032 40.48046465 52.59961084 30.35938049-52.59961084 30.23438048v-60.59376097z"
        fill={
          props.color === "white" || props.color === "mobile-nav"
            ? "#01337d"
            : "#FFFFFF"
        }
      />
    </svg>
  );
}
